<div class="chat-address" [class.chat-address--locked]="locked">
  @if (showLabel) {
    <div class="chat-address__label">
      {{ fieldLabel }}
      @if (required) {
        <span class="chat-address__required" aria-hidden="true">*</span>
      }
    </div>
  }

  @if (!manualOnly) {
    <select
      class="chat-address__control"
      aria-label="Saved addresses"
      [disabled]="locked"
      (change)="onDropdownChange($any($event.target).value)"
    >
      <option value="">Please select...</option>
      @for (saved of savedAddresses; track saved.id) {
        <option [value]="saved.id" [selected]="selectedId === idToString(saved.id)">
          {{ saved.description || formatAddress(saved) }}
        </option>
      }
      <option [value]="NONE_ID" [selected]="selectedId === NONE_ID">None</option>
    </select>
  }

  @if (showManualEntry) {
    <div class="chat-address__manual">
      @if (enterpriseLocation) {
        <label class="chat-address__field-wrap chat-address__field-wrap--full">
          <span class="chat-address__field-label"
            >Address Line <span class="chat-address__required">*</span></span
          >
          <input
            type="text"
            aria-label="Address line"
            [(ngModel)]="address.addressLine"
            [disabled]="locked"
            placeholder="e.g. 14 Finsbury Square"
          />
        </label>
        <label class="chat-address__field-wrap chat-address__field-wrap--full">
          <span class="chat-address__field-label"
            >City Name <span class="chat-address__required">*</span></span
          >
          <input
            type="text"
            aria-label="City name"
            [(ngModel)]="address.cityName"
            [disabled]="locked"
            placeholder="e.g. London"
          />
        </label>
        <label class="chat-address__field-wrap chat-address__field-wrap--full">
          <span class="chat-address__field-label"
            >Country Code <span class="chat-address__required">*</span></span
          >
          <input
            type="text"
            aria-label="Country code"
            [(ngModel)]="address.countryCode"
            [disabled]="locked"
            placeholder="e.g. GB"
          />
        </label>
        <label class="chat-address__field-wrap chat-address__field-wrap--full">
          <span class="chat-address__field-label"
            >Postal Code <span class="chat-address__required">*</span></span
          >
          <input
            type="text"
            aria-label="Postal code"
            [(ngModel)]="address.postalCode"
            [disabled]="locked"
            placeholder="e.g. SW1A 1AA"
          />
        </label>
        <label class="chat-address__field-wrap chat-address__field-wrap--full">
          <span class="chat-address__field-label"
            >Special Instructions <span class="chat-address__required">*</span></span
          >
          <input
            type="text"
            aria-label="Special instructions"
            [(ngModel)]="address.specialInstructions"
            [disabled]="locked"
            placeholder="e.g. Call on arrival"
          />
        </label>
      } @else {
        <label class="chat-address__field-wrap chat-address__field-wrap--full">
          <span class="chat-address__field-label"
            >Building name or number <span class="chat-address__required">*</span></span
          >
          <input
            type="text"
            aria-label="Building name or number"
            [(ngModel)]="address.numberOrName"
            [disabled]="locked"
            placeholder="e.g. 14 or Fountain House"
          />
        </label>
        <label class="chat-address__field-wrap chat-address__field-wrap--full">
          <span class="chat-address__field-label"
            >Street <span class="chat-address__required">*</span></span
          >
          <input
            type="text"
            aria-label="Street"
            [(ngModel)]="address.street"
            [disabled]="locked"
            placeholder="e.g. Finsbury Square"
          />
        </label>
        <label class="chat-address__field-wrap chat-address__field-wrap--full">
          <span class="chat-address__field-label"
            >Town <span class="chat-address__required">*</span></span
          >
          <input
            type="text"
            aria-label="Town"
            [(ngModel)]="address.town"
            [disabled]="locked"
            placeholder="e.g. London"
          />
        </label>
        <label class="chat-address__field-wrap chat-address__field-wrap--full">
          <span class="chat-address__field-label"
            >County <span class="chat-address__required">*</span></span
          >
          <input
            type="text"
            aria-label="County"
            [(ngModel)]="address.county"
            [disabled]="locked"
            placeholder="e.g. Greater London"
          />
        </label>
        <label class="chat-address__field-wrap chat-address__field-wrap--full">
          <span class="chat-address__field-label"
            >Postcode <span class="chat-address__required">*</span></span
          >
          <input
            type="text"
            aria-label="Postcode"
            [(ngModel)]="address.postcode"
            [disabled]="locked"
            placeholder="e.g. EC2A 1BR"
          />
        </label>
        <label class="chat-address__field-wrap chat-address__field-wrap--full">
          <span class="chat-address__field-label"
            >Country <span class="chat-address__required">*</span></span
          >
          <input
            type="text"
            aria-label="Country"
            [(ngModel)]="address.countryCode"
            [disabled]="locked"
            placeholder="e.g. United Kingdom"
          />
        </label>
      }
    </div>
  }

  @if (locked && chosenSummary) {
    <div class="chat-address__chosen">{{ chosenSummary }}</div>
  }

  <div class="chat-address__actions">
    <button
      type="button"
      class="chat-address__continue"
      [disabled]="locked || !isValid"
      (click)="onContinue()"
    >
      Continue
    </button>
  </div>
</div>
